"use client"

import {
  ModuleCard,
  ModuleConfigForm,
  ModuleDetails,
  modulesMockData,
  useModules,
} from "@/features/modules"

export default function UseExistingModules() {
  const {
    filteredModules: modules,
    selectedCardId,
    selectedModule,
    showConfig,
    setShowConfig,
    onCardClick,
    onForgeClick,
  } = useModules(modulesMockData)

  return (
    <div className="flex h-full gap-6 pr-6">
      <div className="w-[380px] overflow-auto rounded-tr-[12px] border border-gray-100 bg-gray-50 px-6 py-4">
        <div className="space-y-6">
          {modules.map((module) => (
            <ModuleCard
              key={module.id}
              {...module}
              isSelected={selectedCardId === module.id}
              onClick={() => onCardClick(module.id)}
            />
          ))}
        </div>
      </div>
      <div className="flex flex-1 gap-6 overflow-hidden">
        {selectedModule && (
          <div
            className={`transition-all duration-300 ${
              showConfig ? "w-1/2" : "w-full"
            }`}
          >
            <ModuleDetails
              module={selectedModule}
              onForgeClick={onForgeClick}
              isConfigOpen={!!showConfig}
            />
          </div>
        )}
        {showConfig && selectedModule && (
          <div className="w-1/2">
            <ModuleConfigForm onClose={() => setShowConfig(false)} />
          </div>
        )}
      </div>
    </div>
  )
}
